import { BadgeTypes } from '@leegality/leegality-react-component-library';
import { ConfigKey } from '@constants';
import { BulkOperationStatus, OtpHeaderValue, RequestStatus } from './types';

export function getBadgeTypeBasisBulkOperationStatus(status) {
  switch (status) {
    case BulkOperationStatus.COMPLETED:
      return BadgeTypes.SUCCESS;
    case BulkOperationStatus.PENDING:
      return BadgeTypes.WARNING;
    case BulkOperationStatus.ONGOING:
      return BadgeTypes.BLUE;
    case BulkOperationStatus.FAILED:
      return BadgeTypes.ERROR;
    default:
      return BadgeTypes.SUCCESS;
  }
}

export const convertEnumToReadableString = (enumString) => {
  if (!enumString) return enumString;
  return enumString
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

export function getBadgeTypeBasisRequestStatus(status) {
  switch (status) {
    case RequestStatus.COMPLETE:
      return BadgeTypes.SUCCESS;
    case RequestStatus.PENDING:
      return BadgeTypes.WARNING;
    case RequestStatus.REJECTION:
      return BadgeTypes.ERROR;
    case RequestStatus.VERIFICATION:
      return BadgeTypes.BLUE;
    case RequestStatus.VERIFICATION_PENDING:
      return BadgeTypes.WARNING;
    case RequestStatus.VERIFICATION_FAILED:
      return BadgeTypes.ERROR;
    default:
      return BadgeTypes.SUCCESS;
  }
}

export function getUserFromJWT(token) {
  const payload = token?.split('.')[1];
  const base64 = payload?.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split('')
      .map((c) => `%${(`00${c.charCodeAt(0).toString(16)}`).slice(-2)}`)
      .join(''),
  );
  const { sub } = JSON.parse(jsonPayload);
  return sub;
}

export function getOTPHeader() {
  const isProd = import.meta.env.VITE_REACT_APP_STAGE === 'prod';
  return isProd ? OtpHeaderValue.CONSENTIN : OtpHeaderValue.CONSENT_TEST;
}

export const hexToRgb = (hex) => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? `${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(result[3], 16)}` : null;
};

// Strict allowlist for color strings that get inlined into a <style> tag.
// Rejects anything that could break out of the declaration (semicolons, braces,
// url(), expressions, etc.). Accepts only short/long hex.
const SAFE_HEX_COLOR_RE = /^#(?:[0-9a-f]{3}|[0-9a-f]{6})$/i;
export const isSafeCssColor = (value) => typeof value === 'string' && SAFE_HEX_COLOR_RE.test(value.trim());
export function getConfigContent(headerText, configKey, fallback = '') {
  return headerText?.find((item) => item.configKey === configKey)?.content || fallback;
}

export function getHeaderTextContent(headerText, configKey, fallback = '') {
  return getConfigContent(headerText, configKey, fallback);
}

export function getBrandColor(headerText, fallback = '') {
  return getConfigContent(headerText, ConfigKey.BRAND_COLOR, fallback);
}
